import type { EDocumentState } from '@/store/slices/eDocumentSlides';
import { FlushDocumentProductEditsPubSub } from '@utils/pubsubs/PubSub';
import { store } from 'store';

/** Sincroniza ediciones locales de EdocumentProductList a Redux antes de persistir. */
export const flushDocumentProductEdits = (): EDocumentState => {
  FlushDocumentProductEditsPubSub.publish();
  return store.getState().eDocument;
};
